<div class="table-responsive mt-3">
  <table class="table table-striped table-sm">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">{{ "pos.id" | translate }}</th>
        <th scope="col" sortable="commercialName" (sort)="onSort($event)">
          {{ "pos.comercialName" | translate }}
        </th>
        <th scope="col" sortable="fiscalName" (sort)="onSort($event)">
          {{ "pos.fiscalName" | translate }}
        </th>
        <th scope="col" sortable="address" (sort)="onSort($event)">
          {{ "pos.address" | translate }}
        </th>
        <th></th>
        <th scope="col">{{ "pos.indicators" | translate }}</th>
        <th scope="col">{{ "common.view" | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of posPaginated; index as i">
        <th scope="row">
          {{ (page - 1) * pageSize + i + 1 }}
        </th>
        <td>
          {{ p.id }}
        </td>
        <td>
          {{ p.commercialName }}
        </td>
        <td>
          {{ p.fiscalName }}
        </td>
        <td>
          {{ fullAdrress(p) }}
        </td>
        <td>
          <span
            *ngIf="p.origin == null || p.origin == ''"
            class="badge badge-pill badge-success"
            >DD</span
          >
          <span *ngIf="p.origin == 'IND'" class="badge badge-pill badge-primary"
            >ID</span
          >
        </td>
        <td>
          <i class="far fa-envelope {{ p.contactIndicator }}"></i>
          &nbsp;&nbsp;
          <i class="far fa-clock {{ p.openIndicator }}"></i>
          &nbsp;&nbsp;
          <i
            class="fas fa-map-marker-alt {{
              hasAddress(p) ? 'Verde' : 'Rojo'
            }}  "
          ></i>
        </td>
        <td>
          <a routerLink="detail/{{ p.id }}"><i class="fas fa-eye"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="d-flex justify-content-between p-2">
  <ngb-pagination
    [collectionSize]="total"
    [(page)]="page"
    [pageSize]="pageSize"
    (pageChange)="refreshPos()"
    [maxSize]="3"
  >
  </ngb-pagination>

  <select
    class="custom-select"
    style="width: auto"
    [(ngModel)]="pageSize"
    (ngModelChange)="refreshPos()"
  >
    <option [ngValue]="10">10 {{ "common.perPage" | translate }}</option>
    <option [ngValue]="15">15 {{ "common.perPage" | translate }}</option>
    <option [ngValue]="20">20 {{ "common.perPage" | translate }}</option>
  </select>
</div>
